import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Context } from '../../Store/context'
import { GetPages } from '../../api/Queries/get'
import Loading from '../loader/loader';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SitesSlider = () => {
    const [pages, setPages] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { i18n } = useTranslation();
    const { showError } = useContext(Context);

    useEffect(() => {
        setIsLoading(true)
        const getCodex = async () => {
            try {
                const data = await GetPages()
                setIsLoading(false)
                setPages(data)
            } catch (error) {
                showError(error.message);
                setIsLoading(false)
            }
        }
        getCodex()
    }, [showError])

    const getLawName = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_name;
        } else if (currentLang === 'en') {
            return laws.eng_name;
        }
        return laws.tm_name;
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
        responsive: [
            {
              breakpoint: 1024, 
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 768, 
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 480, 
              settings: {
                slidesToShow: 2,
              },
            },
          ],
    };

    return (
        <div className='absolute w-full'>
            {isLoading ? <Loading /> : <>
                <Slider {...settings}>
                    {pages?.map((d) => (
                        <Link
                            to={d.link_to_page}
                            key={d.id}
                            className='px-2'
                        >
                                <div className='flex justify-center w-full'>
                                    <img
                                        src={d.photo}
                                        alt="undefined"
                                        className='object-contain h-16 lg:h-24 xxl:h-32'
                                    />
                                </div>
                                <p className='text-center mt-2 text-green font-bold'>
                                    {getLawName(d)}
                                </p>
                        </Link>
                    ))}
                </Slider>
            </>}
        </div>
    )
}

export default SitesSlider